import { CheckCircle2 } from "lucide-react";
import { CONSULTATION_FEE } from "../constants";

export default function ConsultationPayment({ form, upd, onPay, submitting }) {
  const paid = form.consultation_type === "paid";
  return (
    <div>
      <div className="font-serif-display text-xl text-[var(--yp-primary)]">Consultation &amp; Payment</div>
      <p className="text-sm text-[var(--yp-muted)] mt-1">Confirm whether this is your first YourPlants consultation. Payment is required only when a consultation fee applies.</p>

      <div className="mt-5 space-y-3">
        <label className={`flex items-start gap-3 border rounded-2xl p-4 cursor-pointer ${!paid ? "border-[var(--yp-primary)] bg-[var(--yp-surface-alt)]" : "border-[var(--yp-border)]"}`}>
          <input data-testid="sr-consultation-first" type="radio" checked={!paid} onChange={() => upd("consultation_type", "first")} className="mt-1 accent-[var(--yp-primary)]" />
          <span className="flex-1">
            <div className="font-medium">My First Consultation</div>
            <div className="text-xs text-[var(--yp-muted)]">Your first consultation is completely FREE.</div>
          </span>
          <span className="font-semibold text-[var(--yp-success)]">₹0</span>
        </label>
        <label className={`flex items-start gap-3 border rounded-2xl p-4 cursor-pointer ${paid ? "border-[var(--yp-primary)] bg-[var(--yp-surface-alt)]" : "border-[var(--yp-border)]"}`}>
          <input data-testid="sr-consultation-paid" type="radio" checked={paid} onChange={() => upd("consultation_type", "paid")} className="mt-1 accent-[var(--yp-primary)]" />
          <span className="flex-1">
            <div className="font-medium">I've Consulted Before</div>
            <div className="text-xs text-[var(--yp-muted)]">Consultation charges start from ₹{CONSULTATION_FEE}.</div>
          </span>
          <span className="font-semibold">₹{CONSULTATION_FEE} onwards</span>
        </label>
      </div>

      {!paid ? (
        <div className="mt-5 bg-[var(--yp-surface-alt)] border border-[var(--yp-border)] rounded-2xl p-4 flex items-start gap-2">
          <CheckCircle2 size={18} className="text-[var(--yp-success)] shrink-0 mt-0.5" />
          <p className="text-sm text-[var(--yp-muted)]">No payment required. Submit your request and our team will contact you to confirm your free first consultation.</p>
        </div>
      ) : (
        <div className="mt-5 border border-[var(--yp-border)] rounded-2xl p-5">
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="font-medium">Consultation Fee</div>
              <div className="text-xs text-[var(--yp-muted)]">Starting consultation charge</div>
            </div>
            <div className="text-2xl font-semibold text-[var(--yp-primary)]">₹{CONSULTATION_FEE}</div>
          </div>
          <button
            type="button"
            data-testid="sr-pay-button"
            onClick={onPay}
            disabled={submitting}
            className="mt-4 w-full btn-primary rounded-full py-3 text-sm font-medium disabled:opacity-70"
          >
            {submitting ? "Processing…" : `Pay ₹${CONSULTATION_FEE} with Razorpay`}
          </button>
          <p className="mt-2 text-[11px] text-[var(--yp-muted)] text-center">Secure payment via Razorpay · UPI · Cards · Net Banking · Wallets</p>
        </div>
      )}

      <p className="mt-4 text-xs text-[var(--yp-muted)] leading-relaxed">
        <strong>Note:</strong> ₹{CONSULTATION_FEE} is the starting consultation charge. Additional charges may apply
        depending on service type, location, project size or specialist requirement and will be
        communicated before confirmation.
      </p>
    </div>
  );
}
